import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client';

class BHCampaignReminders extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  static modelName = 'BHCampaignReminders'
  static instanceDefaults() {
    return {
      campaign_id: null,
      user_id: null,
      last_reminder_sent: null,
      reminder_count: 0
    }
  }
}

const servicePath = 'bh-campaign-reminders';
const servicePlugin = makeServicePlugin({
  Model: BHCampaignReminders,
  service: feathersClient.service(servicePath),
  servicePath
});

feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
